export default {
  editInsuranceProduct: {
    method: "patch",
    url: "/product/v1/internal/products/insurer/:insurer_product_code",
  },
  onboardProduct: {
    method: "post",
    url: "/product/v1/products/insurer",
  },
  asyncUpdatePricingRules: {
    method: "get",
    url: "/product/v1/internal/pricing/async-update-rules",
  },
  getPresignedUrlForProduct: {
    method: "post",
    url: "/product/v1/internal/storage/presigned-upload",
  },
  issuePolicy: {
    method: "put",
    url: "/policy/v1/dashboard/quotes/:quotes_code",
  },
  downloadPolicyReport: {
    method: "get",
    url: "/policy/v1/dashboard/policies/report",
  },
  downloadQuotationReport: {
    method: "get",
    url: "/policy/v1/dashboard/quotes/report",
  },
  downloadQuotationBulkTemplate: {
    method: "get",
    url: "/policy/v1/dashboard/quotes/report/bulk-template",
  },
  quotationList: {
    method: "get",
    url: "/policy/v1/dashboard/quotes",
  },
  quotationDetail: {
    method: "get",
    url: "/policy/v1/dashboard/quotes/:quotes_code",
  },
  policyList: {
    method: "get",
    url: "/policy/v1/dashboard/policies",
  },
  policyDetail: {
    method: "get",
    url: "/policy/v1/dashboard/policy/:policy_number",
  },
  downloadPolicy: {
    method: "get",
    url: "/policy/v1/policies/:policy_number/download-policy",
  },
  updatePolicy: {
    method: "put",
    url: "/policy/v1/dashboard/policies/:policy_number",
  },
  recordPaymentTransactionOfPolicy: {
    method: "put",
    url: "/policy/v1/dashboard/policies/:policy_number/payment",
  },
  approveQuotation: {
    method: "post",
    url: "/policy/v1/dashboard/quotes/:quotes_code/approve",
  },
  rejectQuotation: {
    method: "post",
    url: "/policy/v1/dashboard/quotes/:quotes_code/reject",
  },
  updateQuotation: {
    method: "put",
    url: "/policy/v1/dashboard/quotes/:quotes_code",
  },
  getPresignedUrl: {
    method: "post",
    url: "/policy/v1/documents/internal/presigned/upload",
  },
  uploadMedicalDocument: {
    method: "post",
    url: "/policy/v1/dashboard/quotes/:quotes_code/document",
  },
  createClaim: {
    method: "post",
    url: "/claim/v1/create",
  },
  getClaimPresignedUrl: {
    method: "post",
    url: "/claim/v1/document/presign",
  },
  getProducts: {
    method: "get",
    url: "/product/v1/products/:product_code/benefits?version=2",
  },
  updateMCUData: {
    method: "post",
    url: "/policy/v1/dashboard/quotes/:quotes_code/cover-letters",
  },

  getSPKReport: {
    method: "get",
    url: "/policy/v1/dashboard/spk-documents",
  },
  downloadSPKReport: {
    method: "get",
    url: "policy/v1/quotes/spk-report/:ref_number",
  },
  quotationHistory: {
    method: "get",
    url: "policy/v1/dashboard/quotes/transaction/:quotes_code",
  },
  uploadBulkData: {
    method: "put",
    url: "/policy/v1/dashboard/quotes/bulk-approval",
  },
  getTaskList: {
    method: "get",
    url: "/policy/v1/dashboard/tasks",
  },
  triggerTaskAction: {
    method: "post",
    url: "/policy/v1/dashboard/tasks/:task_id/actions",
  },
  alterationData: {
    method: "post",
    url: "/policy/v1/dashboard/quotes/alteration",
  },
  policyAlterationData: {
    method: "post",
    url: "/policy/v1/dashboard/policies/alteration",
  },
  regenerateCovernote: {
    method: "get",
    url: "/policy/v1/cover-note/:quotes_code/regenerate",
  },
  regenerateRiplay: {
    method: "post",
    url: "/policy/v1/dashboard/quotes/:quotes_id/riplay-document/regenerate",
  },
  regenerateECertificate: {
    method: "post",
    url: "/policy/v1/dashboard/policies/:policy_number/regenerate",
  },
  downloadBulkUploadTemplate: {
    method: "get",
    url: "/policy/v1/dashboard/quotes/bulk-upload/template",
  },
  uploadBulkPolicyData: {
    method: "post",
    url: "/policy/v1/dashboard/quotes/bulk-upload",
  },
  quotationRollbackStatuses: {
    method: "get",
    url: "/policy/v1/dashboard/quotes/:quotes_code/statuses",
  },
  quotationRollbackStatus: {
    method: "post",
    url: "/policy/v1/dashboard/quotes/:quotes_code/rollback-status",
  },
  quotationBackdateHistory: {
    method: "post",
    url: "/policy/v1/dashboard/quotes/:quotes_code/backdate-history",
  },
  quotationReactivateLink: {
    method: "put",
    url: "/policy/v1/dashboard/reactivate-link",
  },
};
